/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Topplayerreviewed3Inputs */

const id_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai Pemain Teratas`)
};

const ms_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian Pemain Teratas`)
};

const da_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top spillerbedømte`)
};

const de_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am besten bewertet`)
};

const en_us2_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Player Rated`)
};

const es_es2_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor valorados por jugadores`)
};

const es_mx2_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor calificados por jugadores`)
};

const fil_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamataas na Rating ng Manlalaro`)
};

const fr_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mieux notés par les joueurs`)
};

const it_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più votati dai giocatori`)
};

const hu_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb játékos értékelés`)
};

const nl_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best beoordeeld`)
};

const no_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best vurdert av spillere`)
};

const pl_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepiej oceniane przez graczy`)
};

const pt_br2_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores avaliados`)
};

const pt_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhor avaliados por jogadores`)
};

const ro_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai bine cotate de jucători`)
};

const fi_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parhaiten arvioidut`)
};

const sv_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Högst spelarbetyg`)
};

const vi_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh giá cao nhất`)
};

const tr_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En İyi Oyuncu Puanlı`)
};

const cs_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlépe hodnocené hráči`)
};

const bg_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-добре оценени от играчи`)
};

const ru_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие по оценкам`)
};

const uk_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкращі за оцінками гравців`)
};

const ar_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأعلى تقييمًا من اللاعبين`)
};

const hi_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप प्लेयर रेटेड`)
};

const th_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนนผู้เล่นสูงสุด`)
};

const ja_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイヤー評価上位`)
};

const zh_cn2_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最佳玩家评分`)
};

const zh_hant1_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`玩家評分最高`)
};

const ko_components_performancetable_collections_topplayerreviewed3 = /** @type {(inputs: Components_Performancetable_Collections_Topplayerreviewed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플레이어 평점 상위`)
};

/**
* | output |
* | --- |
* | "Top Player Rated" |
*
* @param {Components_Performancetable_Collections_Topplayerreviewed3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_topplayerreviewed3 = /** @type {((inputs?: Components_Performancetable_Collections_Topplayerreviewed3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Topplayerreviewed3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "da") return da_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "de") return de_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "it") return it_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "no") return no_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "th") return th_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_topplayerreviewed3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_topplayerreviewed3(inputs)
	return ko_components_performancetable_collections_topplayerreviewed3(inputs)
});
export { components_performancetable_collections_topplayerreviewed3 as "components.performanceTable.collections.topPlayerReviewed" }